import type { DocPage } from '../schema';

export const pages: DocPage[] = [
  {
    slug: 'sms-alerting-today-full-phone-system-on-the-roadmap',
    title: 'SMS Alerting Today, Full Phone System on the Roadmap',
    summary: "What's shipped now for voice/SMS notification, and how to weigh in on the full business phone system that's community-roadmapped.",
    readMinutes: 3,
    blocks: [
      { type: 'callout', tone: 'info', title: 'Being upfront about where this stands', text: "A full business phone system — call routing, a softphone, support-line integration — is not shipped yet. This page tells you honestly what exists today and how to help shape what gets built next, rather than describing a feature that isn't real." },
      { type: 'heading', text: 'What exists today', level: 2 },
      { type: 'paragraph', text: 'NexusRMM already sends SMS text alerts for critical events through a configured SMS provider, alongside Slack, Teams, and Discord webhook notifications — so your on-call tech gets paged by text without you having to bolt on a separate paging tool. This lives in the ChatOps/alerting settings.' },
      { type: 'heading', text: 'What is roadmapped, not shipped', level: 2 },
      { type: 'list', items: [
        'Inbound call routing tied to tickets and client records',
        'A softphone/dialer built into the technician workspace',
        'Support-line integration with automatic ticket creation from a call',
      ] },
      { type: 'heading', text: 'This is exactly what the community roadmap is for', level: 2 },
      { type: 'paragraph', text: 'Phone system depth is one of the clearest cases where we want MSPs actually running client phone lines to tell us what "done" looks like before we build it — not guess. Vote on the existing phone-system requests or submit your own on the roadmap board, and the features that matter most to the community are what we prioritize next.' },
    ],
    relatedSlugs: [],
  },
];
